export const dayInMs = 1000 * 60 * 60 * 24;
